const RiskScore = ({ score, size = 'md' }) => {
  // Use semi-transparent colors that work in both light and dark mode
  let color = 'text-green-400 bg-green-500/20';
  if (score >= 70) color = 'text-red-400 bg-red-500/20';
  else if (score >= 50) color = 'text-amber-400 bg-amber-500/20';

  // Size variants
  const sizes = {
    sm: 'w-10 h-10 text-sm',
    md: 'w-12 h-12 text-lg',
    lg: 'w-16 h-16 text-2xl',
  };

  return (
    <div
      className={`inline-flex items-center justify-center rounded-lg font-bold ${sizes[size]} ${color}`}
    >
      {score}
    </div>
  );
};

export default RiskScore;
